<template>
    <div>
        <h3 class="text-lg leading-6 font-medium text-secondaryColor mb-4">
            {{ value.label }}
        </h3>
        <p>{{ moment(value.value).format('LLL') }}</p>
    </div>
</template>

<script>
export default {
    name: 'DateTimeAttribute',
    props: ['value']
}
</script>

<style scoped></style>
